module.exports = require("@swa-ui/core/src/DropDown/DropDown.module.scss");